import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import AdminLogin from "./pages/Admin/Login";
import AdminPanel from "./pages/Admin/AdminPanel";
import AdminTenant from "./pages/Admin/AdminTenant";
import AccessPoints from "./pages/User/AccessPoints";
import AdminAttendance from "./pages/User/AdminAttendance";
import AdminRoles from "./pages/User/AdminRoles";
import AdminUsers from "./pages/User/AdminUsers";
import GroupPermissions from "./pages/User/GroupPermissions";
import PersonPermissions from "./pages/User/PersonPermissions";
import Schedules from "./pages/User/Schedules";
import UserLogin from "./pages/User/Login";
import UserPanel from "./pages/User/UserPanel";

function AppRoutes() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<UserLogin />} />
        <Route path="/inicio" element={<UserPanel />} />
        <Route path="/usuarios" element={<AdminUsers />} />
        <Route path="/usuarios/nuevo" element={<AdminUsers />} />
        <Route path="/roles" element={<AdminRoles />} />
        <Route path="/accesos" element={<AccessPoints />} />
        <Route path="/horarios" element={<Schedules />} />
        <Route path="/asistencias" element={<AdminAttendance />} />
        <Route path="/permisos-roles" element={<GroupPermissions />} />
        <Route path="/permisos-usuarios" element={<PersonPermissions />} />
        <Route path="/admin-panel/login" element={<AdminLogin />} />
        <Route path="/admin-panel" element={<AdminPanel />} />
        <Route path="/admin-panel/tenants" element={<AdminTenant />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </AuthProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;